// extracted by mini-css-extract-plugin
export default {"attendance":"Manual_attendance__rI8yH","departure":"Manual_departure__zseAo","mainContainer":"Manual_mainContainer__YfSiL","quickSearch":"Manual_quickSearch__MLAWo"};